import * as cr from "./_cr";
import * as hf from "./_hf";
import * as ht from "./_ht";

import * as CdrC from "./_ccmCdrC";

import { useMdlz } from "./_csMdl";
import { a } from "./_csAbt";

export const useMdlDtmz = () => {

  const _sMdlz = useMdlz();

  const _show = (pz: {
    dtmz: {
      crt: ht.s,
      stt?: ht.s,
      end?: ht.s,
      hdys?: ht.ls, // holliday
      dmds?: ht.ls, // dimmed
    },
/*
    grtStgzAsync?: (dtm: ht.s) => ({
      hdys: ht.ls, // holliday
      dmds: ht.ls, // dimmed
    }),
*/
    onPrs: ( _date: ht.s ) => void,
  }) => {

    //hf.l(`csMdlDtm 31: ${hf.s(pz.dtmz)}`)
    const _dw = cr.d('p') ? 60 : 40;
    const _ls = [
      cr.c(CdrC.N, {
        key: -10,
        abtType: 'mdlCmnz',
        boxStlz: a(`br/1 dh/70 dw/${_dw} sc/lt1`),
        cz: {
          dtmz: pz.dtmz,
          onPrs: ( _dtm: ht.s ) => {
            pz.onPrs(_dtm);
            _sMdlz.set({
              bShow: false,
            })
          },
        }
      })
    ]

    _sMdlz.set({
      bShow: true,
      oClds: _ls,
    })

  }

  return {
    show: _show
  }

};
